import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import { styled } from "@mui/material/styles";

const IconOnlyExportButton = styled(GridToolbarExport)(({ theme }) => ({
  "& .MuiButton-startIcon": {
    margin: 0,
  },
  "& .MuiButton-label": {
    display: "none !important",
  },
}));

const CustomToolbar = () => (
  <GridToolbarContainer>
    <IconOnlyExportButton />
  </GridToolbarContainer>
);

export default CustomToolbar;
